import { render, staticRenderFns } from "./head-order-dialog.vue?vue&type=template&id=3be703f9"
import script from "./head-order-dialog.vue?vue&type=script&lang=js"
export * from "./head-order-dialog.vue?vue&type=script&lang=js"
import style0 from "./head-order-dialog.vue?vue&type=style&index=0&id=3be703f9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports